export const services = [{
	name: 'GPT-3 Development',
	services: [
		'Text generation',
		'Question answering',
		'Chatbot development',
		'Models optimization',
	]
}, {
	name: 'Natural Language Processing',
	services: [
		'Text classification',
		'Information extraction',
		'Text summarization',
		'Named-entity recognition',
	]
}, {
	name: 'ML Software Development',
	services: [
		'ML Ops',
		'Backend development',
		'Data engineering',
		'Deployment',
	]
}]